import { useEffect, useState } from "react";
import { getBranchMenu, getTenantHome } from "@/services/menu";
import { getTenantSlug } from "@/helpers/tenant";

// failKind: 'notFound' (gerçek 404 / tenant yok) | 'error' (ağ, timeout, 5xx).
// Tüketiciler buna göre "Menü Bulunamadı" ya da "Bağlantı Hatası" gösterir.
const classifyError = (err) =>
  err?.response?.status === 404 ? "notFound" : "error";

export const useBranchMenu = (branchSlug) => {
  const [data, setData] = useState(null);
  const [branches, setBranches] = useState([]);
  const [fetching, setFetching] = useState(true);
  const [failKind, setFailKind] = useState(null);

  useEffect(() => {
    const tenantSlug = getTenantSlug();

    if (!tenantSlug) {
      setFailKind("notFound");
      setFetching(false);
      return;
    }

    let cancelled = false;

    const fetchAll = async () => {
      setFetching(true);
      setFailKind(null);
      try {
        // Menü zorunlu; şube listesi opsiyonel — home isteği düşerse menü yine açılır.
        const [menuResponse, homeResponse] = await Promise.allSettled([
          getBranchMenu(tenantSlug, branchSlug),
          getTenantHome(tenantSlug),
        ]);

        if (cancelled) {
          return;
        }

        if (menuResponse.status === "rejected") {
          throw menuResponse.reason;
        }

        const homeBranches =
          homeResponse.status === "fulfilled"
            ? homeResponse.value.data.data.branches
            : [];

        setData(menuResponse.value.data.data);
        setBranches(Array.isArray(homeBranches) ? homeBranches : []);
      } catch (err) {
        if (!cancelled) {
          console.error("[menu] branch menu fetch failed", err);
          setFailKind(classifyError(err));
        }
      } finally {
        if (!cancelled) {
          setFetching(false);
        }
      }
    };

    fetchAll();

    return () => {
      cancelled = true;
    };
  }, [branchSlug]);

  return { data, branches, fetching, failKind };
};

export const useTenantHome = () => {
  const [data, setData] = useState(null);
  const [fetching, setFetching] = useState(true);
  const [failKind, setFailKind] = useState(null);

  useEffect(() => {
    const tenantSlug = getTenantSlug();

    if (!tenantSlug) {
      setFailKind("notFound");
      setFetching(false);
      return;
    }

    let cancelled = false;

    getTenantHome(tenantSlug)
      .then((response) => {
        if (!cancelled) {
          setData(response.data.data);
        }
      })
      .catch((err) => {
        if (cancelled) {
          return;
        }
        console.error("[menu] tenant home fetch failed", err);
        setFailKind(classifyError(err));
      })
      .finally(() => {
        if (!cancelled) {
          setFetching(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { data, fetching, failKind };
};
